import {Component, computed, inject, input, InputSignal} from '@angular/core';
import {Section} from "../../core/definitions/sections-container";
import {MetaField} from "../../core/definitions/meta-field";
import {ObjectCopyFieldComponent} from "../object-copy-field/object-copy-field.component";
import {MatCheckbox} from "@angular/material/checkbox";
import {
  ObjectViewSectionTitleComponent
} from "../../shared/object-view-section-title/object-view-section-title.component";
import {ObjectCopyService} from "../object-copy.service";
import {ObjectCopyMediaComponent} from "../object-copy-media/object-copy-media.component";

@Component({
  selector: 'app-object-copy-section',
  imports: [
    MatCheckbox,
    ObjectCopyFieldComponent,
    ObjectViewSectionTitleComponent,
    ObjectCopyMediaComponent,
  ],
  templateUrl: './object-copy-section.html',
  styleUrl: './object-copy-section.scss'
})
export class ObjectCopySection {
  readonly objectCopyService = inject(ObjectCopyService);

  section: InputSignal<Section> = input();

  copyableFields = computed<MetaField[]>(() =>
    this.objectCopyService.filterCopyableFields(this.section()));

  isSectionSelected = computed<boolean>(() =>
    this.objectCopyService.getIsSectionSelected(this.section()));

  isSectionIndeterminate = computed<boolean>(() =>
    this.objectCopyService.getIsSectionIndeterminate(this.section()));

  isMediaField(field: MetaField) {
    return this.objectCopyService.getIsMediaField(this.section(), field);
  }
}
